import { faFaceFrown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { SearchInput } from '@/header/SearchInput';

interface EmptySearchStateProps {
  searchTerm?: string;
  onSearch?: (e: React.FormEvent<HTMLFormElement>) => void;
  subtitle: string;
}

export function EmptySearchState({
  searchTerm,
  onSearch,
  subtitle,
}: EmptySearchStateProps) {
  return (
    <Wrapper>
      <MessageArea>
        {/* Translation Needed -- LEFT HARDCODED DELIBERATELY, recorded here so
            the next group inherits the measurement rather than the guess. The
            string is legacy's own (`buddyboss-theme/template-parts/
            content-none.php:13`) and the catalogue has it, but only half
            translated: WPML unit 3060 `No results found!` carries EN and PT_BR
            and NO es/fr row (`select u.id,t.language from translatable_units u
            join translations t ... where u.id=3060` -> 2 rows, EN + PT_BR). The
            fully-translated neighbour, `wbs.no-results-found` (unit 22172, 4/4),
            is the same phrase WITHOUT the exclamation mark, so adopting it would
            trade legacy's punctuation for coverage.
            Neither call site is this group's row -- W4.10 owns only the
            `subtitle` prop -- and the two `ArticleListingPage` consumers
            (`tutorials.index.tsx`, `news.index.tsx`) are Wave-5. Whoever takes
            them decides between the two keys; until then the heading stays
            English for all four languages, which is what it already did. */}
        <Heading>No results found!</Heading>
        <Subtitle>{subtitle}</Subtitle>
        <SadIcon icon={faFaceFrown} />
      </MessageArea>

      {onSearch && (
        <SearchArea>
          <SearchInput
            key={searchTerm ?? ''}
            defaultValue={searchTerm}
            onSubmit={onSearch}
          />
        </SearchArea>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px 0;
  width: 100%;
`;

const MessageArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 17px;
  text-align: center;
`;

const Heading = styled.h1`
  color: var(--grey-blue-400);
  font-family: var(--raleway);
  font-size: 34px;
  font-weight: 600;
  margin: 0;
`;

const Subtitle = styled.h2`
  color: var(--grey-550);
  font-family: var(--raleway);
  font-size: 18px;
  font-weight: 300;
  margin: 0;
`;

const SadIcon = styled(FontAwesomeIcon)`
  color: var(--grey-500);
  font-size: 45px;
  margin: 20px 0 30px;
`;

const SearchArea = styled.div`
  max-width: 200px;
  width: 100%;
`;
